import React from 'react';
import Img from 'gatsby-image';

const Image = ({ input }) => <Img fluid={input.primary.image.localFile.childImageSharp.fluid} />;

export default Image;
